import type { ReconcilableTurn } from './mergeRunCompletionAnnouncements'

/** Adopt only the server message a completed action explicitly names. */
export function adoptPersistedMessage<T extends ReconcilableTurn>(
  current: T[],
  saved: T,
  existing: 'preserve' | 'replace' = 'preserve',
): T[] {
  const index = current.findIndex((turn) => turn.id === saved.id || turn.serverToken === saved.id)
  if (index === -1) return [...current, saved]
  if (existing === 'preserve') return current
  return current.map((turn, at) => at === index
    ? { ...turn, ...saved, id: turn.id, ...(turn.serverToken ? { serverToken: turn.serverToken } : {}) }
    : turn)
}
